import { Card } from "@/components/ui/card";
import { ClientHealthDashboard } from "@/components/client-health/ClientHealthDashboard";
import { HealthScoreOverview } from "@/components/client-health/HealthScoreOverview";
import { ChurnRiskAlerts } from "@/components/client-health/ChurnRiskAlerts";

export default function ClientHealth() {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Client Health & Success</h1>
        <p className="text-muted-foreground">Monitor client satisfaction and identify at-risk accounts</p>
      </div>

      <HealthScoreOverview />
      <ChurnRiskAlerts />
      <ClientHealthDashboard />
    </div>
  );
}